import {scoreBadge} from "../../utilities/general"

export const OrientationCompetencyScores = ({week, osr}) => {
    const clinicalBadge = scoreBadge(osr.category_scores["Clinical Practice"], 100)
    const assessmentBadge = scoreBadge(osr.category_scores["Assessment & Care"], 100)
    const medicationBadge = scoreBadge(osr.category_scores["Medication Management"], 100)
    const preventionBadge = scoreBadge(osr.category_scores["Prevention, Safety & Quality"], 100)
    const educationBadge = scoreBadge(osr.category_scores["Education, Communication & Collaboration"], 100)
    const professionalismBadge = scoreBadge(osr.category_scores["Professionalism"], 100)

    return (
        <div className="col-12  col-lg-4 pb-0 mb-0 ">
            <div className="d-flex flex-wrap fw-semibold fs-6 mb-2 pe-2">Week {week} Competency Domain Scores</div>
            <div className="row">
                <div className="d-flex align-items-center flex-column mb-2 ">
                    <div className="d-flex justify-content-between w-100">
                        <span className="fw-semibold fs-7">
                            <i className={`fas fa-circle me-1 ${clinicalBadge.badgeColor}`}></i>
                            Clinical Practice
                        </span>
                        <span className="fw-bold fs-7">{clinicalBadge.score}%</span>
                    </div>
                </div>
                <div className="d-flex align-items-center flex-column mb-2 ">
                    <div className="d-flex justify-content-between w-100">
                        <span className="fw-semibold fs-7">
                            <i className={`fas fa-circle me-1 ${assessmentBadge.badgeColor}`}></i>
                            Assessment &amp; Care
                        </span>
                        <span className="fw-bold fs-7">{assessmentBadge.score}%</span>
                    </div>
                </div>
                <div className="d-flex align-items-center flex-column mb-2 ">
                    <div className="d-flex justify-content-between w-100">
                        <span className="fw-semibold fs-7">
                            <i className={`fas fa-circle me-1 ${medicationBadge.badgeColor}`}></i>
                            Medication Management
                        </span>
                        <span className="fw-bold fs-7">{medicationBadge.score}%</span>
                    </div>
                </div>
                <div className="d-flex align-items-center flex-column mb-2 ">
                    <div className="d-flex justify-content-between w-100">
                        <span className="fw-semibold fs-7">
                            <i className={`fas fa-circle me-1 ${preventionBadge.badgeColor}`}></i>
                            Prevention &amp; Safety
                        </span>
                        <span className="fw-bold fs-7">{preventionBadge.score}%</span>
                    </div>
                </div>
                <div className="d-flex align-items-center flex-column mb-2 ">
                    <div className="d-flex justify-content-between w-100">
                        <span className="fw-semibold fs-7">
                            <i className={`fas fa-circle me-1 ${educationBadge.badgeColor}`}></i>
                            Education, Communication &amp; Collaboration
                        </span>
                        <span className="fw-bold fs-7">{educationBadge.score}%</span>
                    </div>
                </div>
                <div className="d-flex align-items-center flex-column mb-2 ">
                    <div className="d-flex justify-content-between w-100 ">
                        <span className="fw-semibold fs-7">
                            <i className={`fas fa-circle me-1 ${professionalismBadge.badgeColor}`}></i>
                            Professionalism
                        </span>
                        <span className="fw-bold fs-7">{professionalismBadge.score}%</span>
                    </div>
                </div>
            </div>
        </div>
    )
}
